import { render, staticRenderFns } from "./PrintedTickets.vue?vue&type=template&id=1bd6cbb0&scoped=true"
import script from "./PrintedTickets.vue?vue&type=script&lang=js"
export * from "./PrintedTickets.vue?vue&type=script&lang=js"
import style0 from "./PrintedTickets.vue?vue&type=style&index=0&id=1bd6cbb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd6cbb0",
  null
  
)

export default component.exports